import React from 'react';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { selectFlaggedContentVisibility } from 'app/selectors/bibs/ContentWarningsSelector';
import { selectFlagEntities } from 'app/selectors/EntitiesSelector';
import contentWarningActions from 'app/actions/ContentWarningActions';
import { FLAG_TYPES } from 'app/constants/FlagsConstants';

export default function useFlags(contentId) {
  const allFlags = useSelector(selectFlagEntities);
  const flaggedContentVisibility = useSelector(selectFlaggedContentVisibility);

  const flags = allFlags?.get(contentId.toString()) || Immutable.List();
  const flaggedTypes = flags.get('flaggedTypes', Immutable.List());

  function getContentVisibility() {
    if (!flaggedContentVisibility) return { spoilersVisible: false, offensiveContentVisible: false };
    const ugcIdToLookup = flaggedContentVisibility.has(contentId.toString()) ? contentId.toString() : 'all';
    const spoilersVisible = flaggedContentVisibility.getIn([ugcIdToLookup, 'spoilersVisible']);
    const offensiveContentVisible = flaggedContentVisibility.getIn([ugcIdToLookup, 'offensiveContentVisible']);
    return { spoilersVisible, offensiveContentVisible };
  }

  function isContentHidden() {
    const visibilitySettings = getContentVisibility();
    return (
      (flaggedTypes.includes(FLAG_TYPES.SPOILER) && !visibilitySettings.spoilersVisible) ||
      (flaggedTypes.includes(FLAG_TYPES.OFFENSIVE) && !visibilitySettings.offensiveContentVisible)
    );
  }

  function constructPlaceholder() {
    let message = null;
    if (flaggedTypes.includes(FLAG_TYPES.SPOILER)) message = <FormattedMessage id="content_is_spoiler" />;
    if (flaggedTypes.includes(FLAG_TYPES.OFFENSIVE)) message = <FormattedMessage id="content_is_offensive" />;
    if (flaggedTypes.includes(FLAG_TYPES.OFFENSIVE) && flaggedTypes.includes(FLAG_TYPES.SPOILER))
      message = <FormattedMessage id="content_is_offensive_spoiler" />;
    return <span className="placeholder">{message}</span>;
  }

  const dispatch = useDispatch();
  function toggleContent(value) {
    dispatch(contentWarningActions.toggleContent({ contentId, value }));
  }

  return { flags, contentIsHidden: isContentHidden(), placeholder: constructPlaceholder(), toggleContent };
}
